<template>
	<h3 :class="className" @click="toggleCalendar">
		<a class="link_setting cal_fold_btn">
			<slot></slot>
			<span class="ico_cafe ico_arrow"></span>
		</a>
	</h3>
</template>

<script>
	import { mapState, mapMutations } from 'vuex';

	export default {
		computed: {
			...mapState(['isFolded']),
			className() {
				return ['setting_month', this.isFolded ? 'tit_calendar_scroll' : ''];
			},
		},
		methods: mapMutations(['toggleCalendar']),
	}
</script>
